import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table as Table2,
    Pagination,
    Checkbox,
    Modal,
    Upload,
    Transfer,
    Form,
    Col,
    Rate,
    Divider,
    Radio,
    message,
    Popconfirm,
    Alert, Spin, Switch, Image
} from 'antd';
import { Redirect, Link, withRouter } from 'react-router-dom';
import store from "../store/store.js";
import { DeleteOutlined, UploadOutlined, EditOutlined, PlusOutlined, FolderAddOutlined } from '@ant-design/icons'
import moment from 'moment';
import 'braft-editor/dist/index.css'
import BraftEditor from 'braft-editor'
import Table from 'braft-extensions/dist/table'
import { ContentUtils } from 'braft-utils'

const { Option, OptGroup } = Select;
const { TextArea } = Input;
const { RangePicker } = DatePicker;
const options = {
    defaultColumns: 3, // 默认列数
    defaultRows: 3, // 默认行数
    withDropdown: true, // 插入表格前是否弹出下拉菜单
    columnResizable: true, // 是否允许拖动调整列宽，默认false
    exportAttrString: 'border="1" style="border-collapse: collapse"', // 指定输出HTML时附加到table标签上的属性字符串
    // includeEditors: [], // 指定该模块对哪些BraftEditor生效，不传此属性则对所有BraftEditor有效
    // excludeEditors: []  // 指定该模块对哪些BraftEditor无效
}

BraftEditor.use(Table(options))

class Edit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {
                id: props.id,
                editorState: BraftEditor.createEditorState(null),
            },
            visible: false,
            loading: false,
            loading2: false,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {


    }

    sub() {
        let that = this
        that.setState({
            loading: true
        })
        let arr = that.state.condition
        arr.type = 1
        fetch('/Zaiti/doView', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    message.success(data.msg);
                    this.props.refresh()
                    this.mdchange()
                } else {
                    message.error(data.msg)
                    that.setState({
                        loading: false
                    })
                }
            })
    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            fetch('/Zaiti/view', {
                method: "POST",
                body: JSON.stringify({
                    id: this.state.condition.id,
                    type: 1
                })
            })
                .then(res => res.json())
                .then(data => {
                    data.data.editorState = BraftEditor.createEditorState(data.data.content)
                    data.condition = data.data ? data.data : {}
                    that.setState({
                        ...data
                    })
                })
        } else {
            that.setState({
                condition: {
                    id: this.props.id,
                    editorState: BraftEditor.createEditorState(null),
                },
                loading: false
            })
        }
    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.condition, { [name]: dateString })
        this.setState({
            condition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(dates, dateStrings)
        let data = Object.assign({}, this.state.condition, { [name + '1']: dateStrings[0], [name + '2']: dateStrings[1] })
        this.setState({
            condition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, { [name]: value })
        this.setState({
            condition: data
        })
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, { [name]: value })
        this.setState({
            condition: data
        })
    }

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, { [name]: value })
        this.setState({
            condition: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Option value={item.id} key={index}>{item.name}</Option>
            )
        }
    }

    arrradio(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Radio value={item.id} key={index}>{item.name}</Radio>
            )
        }
    }

    arrCheckbox(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Checkbox value={item.id} key={index}>{item.name}</Checkbox>
            )
        }
    }

    editorChange = (editorState) => {
        let data = Object.assign({}, this.state.condition, { editorState: editorState, content: editorState.toHTML() })
        this.setState({
            condition: data
        })
    }

    // 上传图片
    picChange(name, info) {
        // console.log(info)
        if (info.file.status === 'uploading') {
            this.setState({ loading2: true });
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            // console.log(info.file.response)

            var fjlist = this.state.condition[name]
            if (!fjlist) {
                fjlist = []
            }
            if (info.file.response.status == 0) {
                message.error(info.file.response.msg)
                return;
            }
            fjlist = fjlist.concat(info.file.response)
            let data = Object.assign({}, this.state.condition, { [name]: fjlist })
            this.setState({
                condition: data,
                loading2: false,
            })
        }
    };

    delpic(index, name, e) {
        var fjlist = this.state.condition[name]
        fjlist.splice(index, 1)
        let data = Object.assign({}, this.state.condition, { [name]: fjlist })
        this.setState({
            condition: data,
        })
    }

    // 富文本上传附件
    picChange2(name, info) {
        // console.log(info)
        if (info.file.status === 'uploading') {
            this.setState({ loading2: true });
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            // console.log(info.file.response)
            if (info.file.response.status == 0) {
                message.error(info.file.response.msg)
                return;
            }
            let text = ContentUtils.insertText(this.state.condition[name], info.file.response.name, ['COLOR-00F', 'UNDERLINE'], {
                type: 'LINK', mutability: 'MUTABLE', data: {
                    href: info.file.response.url, target: '_blank',
                },
            })
            let data = Object.assign({}, this.state.condition, {
                [name]: text, content: text.toHTML()
            })
            this.setState({
                condition: data
            })
        }
    };

    getCompanyInfo = () => {
        let that = this
        let name = that.state.condition.name
        that.setState({
            getting: true
        })
        fetch('/Zaiti/getCompanyInfo', {
            method: "POST",
            body: JSON.stringify({
                name,
            })
        })
            .then(res => res.json())
            .then(data => {
                that.setState({
                    getting: false
                })
                if (data.status == 0) {
                    message.error(data.msg)
                    return
                }
                let condition = Object.assign({}, this.state.condition, { ...data.data })
                this.setState({
                    condition
                })
            })
    }

    render() {
        //多媒体上传
        const myUploadFn = (param) => {

            const serverURL = '/Ajax/uploads'
            const xhr = new XMLHttpRequest
            const fd = new FormData()

            const successFn = (response) => {
                // 假设服务端直接返回文件上传后的地址
                // 上传成功后调用param.success并传入上传后的文件地址
                let reg = /["\\]/g
                var url = xhr.responseText.replace(reg, "");
                param.success({
                    // url: xhr.responseText,
                    url: url,
                    meta: {
                        // id: 'xxx',
                        // title: 'xxx',
                        // alt: 'xxx',
                        loop: false, // 指定音视频是否循环播放
                        autoPlay: false, // 指定音视频是否自动播放
                        controls: true, // 指定音视频是否显示控制栏
                        poster: '', // 指定视频播放器的封面
                    }
                })
            }

            const progressFn = (event) => {
                // 上传进度发生变化时调用param.progress
                param.progress(event.loaded / event.total * 100)
            }

            const errorFn = (response) => {
                // 上传发生错误时调用param.error
                param.error({
                    msg: 'unable to upload.'
                })
            }

            xhr.upload.addEventListener("progress", progressFn, false)
            xhr.addEventListener("load", successFn, false)
            xhr.addEventListener("error", errorFn, false)
            xhr.addEventListener("abort", errorFn, false)

            fd.append('file', param.file)
            xhr.open('POST', serverURL, true)
            xhr.send(fd)

        }
        const controls = [
            'undo', 'redo', 'separator',
            'font-size', 'line-height', 'letter-spacing', 'separator',
            'text-color', 'bold', 'italic', 'underline', 'strike-through', 'separator',
            'superscript', 'subscript', 'remove-styles', 'separator', 'text-indent', 'text-align', 'separator',
            'headings', 'list-ul', 'list-ol', 'code', 'blockquote', 'table', 'media', 'separator',
            'hr', 'link', 'separator', 'separator',
            'clear'
        ]
        const extendControls = [
            {
                key: 'antd-uploader',
                type: 'component',
                component: (
                    <Upload
                        showUploadList={false}
                        action="/Ajax/upload"
                        onChange={this.picChange2.bind(this, 'editorState')}
                    >
                        {/* 这里的按钮最好加上type="button"，以避免在表单容器中触发表单提交，用Antd的Button组件则无需如此 */}
                        <Button className="control-item button upload-button" data-title="上传附件">
                            <FolderAddOutlined />
                        </Button>
                    </Upload>
                )
            }
        ]
        let zsyx = this.state.condition.zsyx || [];
        return (
            <>
                {this.props.id ?
                    <a href='javascript:void(0)' onClick={this.mdchange.bind(this)}>编辑</a>
                    :

                    <>
                        <Button type="primary" icon={<PlusOutlined />}
                            onClick={this.mdchange.bind(this)}>新增载体</Button>
                    </>
                }

                <Modal title="编辑" maskClosable={false} destroyOnClose={true} width={900} visible={this.state.visible}
                    onCancel={this.mdchange.bind(this)} footer={null}>
                    <Form
                        layout="vertical"
                        // labelCol={{ span: 3 }}
                        wrapperCol={{ span: 24 }}
                        autoComplete="off"
                    >
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="厂房名称"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.name ? this.state.condition.name : null}
                                        onChange={this.onChange.bind(this, 'name')} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="地址"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.address ? this.state.condition.address : null}
                                        onChange={this.onChange.bind(this, 'address')} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="总占地面积"
                                // required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.zzdmj ? this.state.condition.zzdmj : null}
                                        onChange={this.onChange.bind(this, 'zzdmj')} suffix="㎡" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="总建筑面积"
                                // required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.zjzmj ? this.state.condition.zjzmj : null}
                                        onChange={this.onChange.bind(this, 'zjzmj')} suffix="㎡" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="租售意向"
                                    required={true}
                                >
                                    <Checkbox.Group style={{ width: '100%' }}
                                        value={this.state.condition.zsyx ? this.state.condition.zsyx : null}
                                        onChange={this.onSelChange.bind(this, 'zsyx')} options={this.state.zsyx_react}></Checkbox.Group>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="租售面积"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.zsmj ? this.state.condition.zsmj : null}
                                        onChange={this.onChange.bind(this, 'zsmj')} suffix="㎡" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="载体性质"
                                    required={true}
                                >
                                    <Radio.Group onChange={this.onChange.bind(this, 'ztxz')}
                                        value={this.state.condition.ztxz ? this.state.condition.ztxz : null}>
                                        {this.arrradio(this.state.ztxz_react)}
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="载体用途"
                                    required={true}
                                >
                                    <Radio.Group onChange={this.onChange.bind(this, 'ztyt')}
                                        value={this.state.condition.ztyt ? this.state.condition.ztyt : null}>
                                        {this.arrradio(this.state.ztyt_react)}
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="层数"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                        type="number"
                                        value={this.state.condition.cs ? this.state.condition.cs : null}
                                        onChange={this.onChange.bind(this, 'cs')} suffix="层" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="层高"
                                // required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.cg ? this.state.condition.cg : null}
                                        onChange={this.onChange.bind(this, 'cg')} suffix="m" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="净高"
                                // required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.jg ? this.state.condition.jg : null}
                                        onChange={this.onChange.bind(this, 'jg')} suffix="m" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="地面承压"
                                // required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.dmcy ? this.state.condition.dmcy : null}
                                        onChange={this.onChange.bind(this, 'dmcy')} suffix="T/㎡" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="消防等级"
                                // required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.xfdj ? this.state.condition.xfdj : null}
                                        onChange={this.onChange.bind(this, 'xfdj')} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="天车情况"
                                // required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.tcqk ? this.state.condition.tcqk : null}
                                        onChange={this.onChange.bind(this, 'tcqk')} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="洁净间面积"
                                // required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.jjjmj ? this.state.condition.jjjmj : null}
                                        onChange={this.onChange.bind(this, 'jjjmj')} suffix="㎡" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="洁净度"
                                // required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.jjd ? this.state.condition.jjd : null}
                                        onChange={this.onChange.bind(this, 'jjd')} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="变压器"
                                // required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.byq ? this.state.condition.byq : null}
                                        onChange={this.onChange.bind(this, 'byq')} suffix="KVA" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="办公区域面积"
                                // required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.bgqymj ? this.state.condition.bgqymj : null}
                                        onChange={this.onChange.bind(this, 'bgqymj')} suffix="㎡" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="房地产权证"
                                // required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.fdcqz ? this.state.condition.fdcqz : null}
                                        onChange={this.onChange.bind(this, 'fdcqz')} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="是否独门独院"
                                // required={true}
                                >
                                    <Radio.Group onChange={this.onChange.bind(this, 'sfdmdy')}
                                        value={this.state.condition.sfdmdy ? this.state.condition.sfdmdy : null}>
                                        {this.arrradio(this.state.sf_react)}
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="租赁价格"
                                    required={zsyx.includes('1') ? true : false}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.zljg ? this.state.condition.zljg : null}
                                        onChange={this.onChange.bind(this, 'zljg')} suffix="元/月/平米" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="出售价格"
                                    required={zsyx.includes('2') ? true : false}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.csjg ? this.state.condition.csjg : null}
                                        onChange={this.onChange.bind(this, 'csjg')} suffix="万元" />
                                </Form.Item>
                            </Col>

                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="物业费"
                                // required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.wyf ? this.state.condition.wyf : null}
                                        onChange={this.onChange.bind(this, 'wyf')} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="能源费"
                                // required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.nyf ? this.state.condition.nyf : null}
                                        onChange={this.onChange.bind(this, 'nyf')} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="是否有中介费"
                                    required={true}
                                >
                                    <Radio.Group onChange={this.onChange.bind(this, 'sfyzjf')}
                                        value={this.state.condition.sfyzjf ? this.state.condition.sfyzjf : null}>
                                        {this.arrradio(this.state.sf_react)}
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                            {this.state.condition.sfyzjf == 1 && <>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="中介费标准"
                                        required={true}
                                    >
                                        <Input placeholder="请输入"
                                            value={this.state.condition.zjfbz ? this.state.condition.zjfbz : null}
                                            onChange={this.onChange.bind(this, 'zjfbz')} />
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="是否溢价"
                                        required={true}
                                    >
                                        <Radio.Group onChange={this.onChange.bind(this, 'sfyyj')}
                                            value={this.state.condition.sfyyj ? this.state.condition.sfyyj : null}>
                                            {this.arrradio(this.state.sf_react)}
                                        </Radio.Group>
                                    </Form.Item>
                                </Col>
                                {this.state.condition.sfyyj == 1 ? <>
                                    <Col className="gutter-row" span={12}>
                                        <Form.Item
                                            label="溢价"
                                            required={true}
                                        >
                                            <Input placeholder="请输入"
                                                value={this.state.condition.yj ? this.state.condition.yj : null}
                                                onChange={this.onChange.bind(this, 'yj')} />
                                        </Form.Item>
                                    </Col>
                                </> : <Col className="gutter-row" span={12}></Col>}
                            </>}
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="信息负责人"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.xxfzr ? this.state.condition.xxfzr : null}
                                        onChange={this.onChange.bind(this, 'xxfzr')} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="状态"
                                    required={true}
                                >
                                    <Checkbox.Group style={{ width: '100%' }}
                                        value={this.state.condition.status ? this.state.condition.status : null}
                                        onChange={this.onSelChange.bind(this, 'status')} options={this.state.status_react}></Checkbox.Group>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={24}>
                                <Form.Item
                                    label="备注"
                                // required={true}
                                >
                                    <TextArea placeholder="厂房情况、保证金情况、支付方式等"
                                        rows={5}
                                        value={this.state.condition.bz ? this.state.condition.bz : null}
                                        onChange={this.onChange.bind(this, 'bz')} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={24}>
                                <Form.Item
                                    label="图片"
                                >
                                    <Row justify="space-between">
                                        <Space align="center">
                                            <Upload
                                                showUploadList={false}
                                                action="/Ajax/upload"
                                                listType="picture-card"
                                                onChange={this.picChange.bind(this, 'imglist')}
                                                multiple={true}
                                            >
                                                <PlusOutlined />
                                            </Upload>
                                            <Image.PreviewGroup
                                                preview={{
                                                    onChange: (current, prev) => console.log(`current index: ${current}, prev index: ${prev}`),
                                                }}
                                            >
                                                <Space wrap>
                                                    {this.state.condition.imglist ? this.state.condition.imglist.map((item, index) =>
                                                        <div className='picItem'>
                                                            <Image
                                                                width={100}
                                                                height={100}
                                                                src={item.url}
                                                            />
                                                            <DeleteOutlined className="hongse"
                                                                onClick={this.delpic.bind(this, index, 'imglist')} />
                                                        </div>
                                                    ) : null}

                                                </Space>
                                            </Image.PreviewGroup>
                                        </Space>
                                    </Row>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={24}>
                                <Form.Item>
                                    <Row justify={"center"}>
                                        <Button type='primary' onClick={this.sub.bind(this)}
                                            loading={this.state.loading}>提交</Button>
                                    </Row>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
            </>
        )
    }
}

export default Edit
